export default function getSidebarItemTitle(item, dictionary) {
  if (!item) return ""
  const general = dictionary?.find(
    (dictionaryItem) => dictionaryItem.key?.current === "general"
  )?.value

  return (
    item.detailed_title ||
    item.faqGlossarySport?.name ||
    item.sport?.name ||
    item.title ||
    general ||
    ""
  )
}
